'use strict';

var PooledSeasonalityInputDataFilterModalDirective = function PooledSeasonalityInputDataFilterModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/input-data-filter-modal.html'),
    controller: 'PooledSeasonalityInputDataFilterModalController',
    scope: {
      cabins: '=',
      rtps: '=',
      dowGroups: '=',
      defaultFilters: '=',
      showModal: '='
    }
  };
};
PooledSeasonalityInputDataFilterModalDirective.$inject = [];
module.exports = PooledSeasonalityInputDataFilterModalDirective;